import { faqConstants, uriConstants} from '../../constants'
import { defaultService } from '../../services'
import { errorMessages } from '../../messages'
import { alertActions } from '../'

export const faqActions = {
  load,
  select,
  search,
}

/*********
 로딩
**********/

function load(params) {
  return async dispatch => {
    dispatch(apiAction(faqConstants.LOAD_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_FAQ + paramStr,

    })
    .then(
      response => {
        dispatch(apiAction(faqConstants.LOAD_SUCCESS, response))
      },
      error => {
        dispatch(apiAction(faqConstants.LOAD_FAILURE, error))
        dispatch(apiError(error))
      }
    )
  }
}

/*********
 검색
**********/


function search(keyword) {
  return async dispatch => {
    dispatch(apiAction(faqConstants.SEARCH_REQUEST))

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_FAQ,

    })
    .then(
      response => {
        dispatch(apiAction(faqConstants.SEARCH_SUCCESS, response))
      },
      error => {
        dispatch(apiAction(faqConstants.SEARCH_FAILURE, error))
        dispatch(apiError(error))
      }
    )
  }
}


/*********
 셀렉트
**********/

function select(params) {
  return async dispatch => {
    dispatch(request())
  }
  function request() {
    return {
      type: faqConstants.SELECT_REQUEST,
      params
    }
  }
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = {type};
  response && (resultObj.response = response)
  return resultObj;
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}
